/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const smtpSocketSecuritySchema = z.enum([
  'auto',
  'startTls',
  'sslOnConnect',
  'none',
]);
